import { render, staticRenderFns } from "./BaseLabeledRow.vue?vue&type=template&id=9cd6fa34&scoped=true&"
import script from "./BaseLabeledRow.vue?vue&type=script&lang=ts&"
export * from "./BaseLabeledRow.vue?vue&type=script&lang=ts&"
import style0 from "./BaseLabeledRow.vue?vue&type=style&index=0&id=9cd6fa34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd6fa34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCol,VRow,VSubheader})
